import { render } from "./rms_dictionary_list.vue?vue&type=template&id=315f7124"
import script from "./rms_dictionary_list.vue?vue&type=script&lang=js"
export * from "./rms_dictionary_list.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn\\esp-rms-xhjr-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__